/*
 * On smaller devices, display the Action as list item which is option in a menu.
 * On larger devices, display the Actions as an icon with a tooltip.
 *
 * The icon will be placed in the 'icon' slot.
 * The tooltip will be placed in the 'tooltip' slot.
 * The label will be placed in the 'label' slot.
 */
<template>
  <span>
    <v-list-item v-if="useMenu()" @click="onAction()">
      <v-list-item-title>
        <slot name="icon"></slot> <slot name="label"></slot>
      </v-list-item-title>
    </v-list-item>
    <v-layout v-if="!useMenu()">
      <v-flex>
        <v-tooltip top open-delay="1000">
          <template v-slot:activator="{ on: tooltip }">
            <v-btn icon v-on="tooltip" @click="onAction()"><slot name="icon"></slot></v-btn>
          </template>
          <slot name="tooltip"></slot>
        </v-tooltip>
      </v-flex>
    </v-layout>
  </span>
</template>

<script>
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ActionBase from './ActionBase.vue';

@Component
export default class Action extends ActionBase {
  @Prop(Function) onAction;
}
</script>

<style scoped>
.v-list-item__title {
  text-align: left;   /* Override the application default which is center */
}
</style>
